import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2265b5b3&scoped=true&lang=html&"
import script from "./storeHome.js?vue&type=script&lang=js&"
export * from "./storeHome.js?vue&type=script&lang=js&"
import style0 from "./storeHome.styl?vue&type=style&index=0&id=2265b5b3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2265b5b3",
  null
  
)

export default component.exports